
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../../components/base/PageLayout';
import columnData from '../../../data/wisdom-columns.json';

type WisdomColumn = { slug:string; title:string; category:'hospitality'|'etiquette'|'butler-skills'|'elegance'; date:string; sections:Array<{heading:string;paragraphs:string[]}> };
const columnCategoryNames:Record<WisdomColumn['category'],string> = { hospitality:'おもてなしの心', etiquette:'フォーマルマナー', 'butler-skills':'執事スキル', elegance:'日常の品格' };

const WisdomArticles: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'すべて' },
    { id: 'hospitality', name: 'おもてなしの心' },
    { id: 'etiquette', name: 'フォーマルマナー' },
    { id: 'butler-skills', name: '執事スキル' },
    { id: 'elegance', name: '日常の品格' }
  ];

  const articles = [
    {
      id: 1,
      title: "完璧なテーブルマナーの基本",
      excerpt: "フォーマルなディナーでの正しい作法と、美しい所作について詳しく解説いたします。",
      category: "etiquette",
      categoryName: "フォーマルマナー",
      readTime: "5分",
      image: "/images/generated/seq-table-manners-asian-431a82.jpg",
      href: "/wisdom/articles/table-manners"
    },
    {
      id: 2,
      title: "ビジネスシーンでの立ち振る舞い",
      excerpt: "プロフェッショナルとしての品格を保つための姿勢と動作のポイントをご紹介します。",
      category: "elegance",
      categoryName: "日常の品格",
      readTime: "7分",
      image: "/images/generated/seq-business-manner-asian-c73e1a.jpg",
      href: "/wisdom/articles/posture"
    },
    {
      id: 3,
      title: "上質なコミュニケーション術",
      excerpt: "相手の心に響く話し方と、信頼関係を築くための会話のテクニックをお教えします。",
      category: "butler-skills",
      categoryName: "執事スキル",
      readTime: "6分",
      image: "/images/generated/seq-communication-asian-e062c1.jpg",
      href: "/wisdom/articles/communication"
    },
    {
      id: 4,
      title: "エレガントな服装の選び方",
      excerpt: "TPOに応じた装いの基本と、品格を演出するドレスコードについて解説いたします。",
      category: "etiquette",
      categoryName: "フォーマルマナー",
      readTime: "8分",
      image: "/images/generated/seq-dress-code-asian-6e50b5.jpg",
      href: "/wisdom/articles/dress-code"
    },
    {
      id: 5,
      title: "VIPサービスの心得",
      excerpt: "特別なお客様への最高級のおもてなしと、期待を超えるサービスの提供方法をご紹介します。",
      category: "hospitality",
      categoryName: "おもてなしの心",
      readTime: "10分",
      image: "/images/generated/seq-vip-service-asian-f630f7.jpg",
      href: "/wisdom/articles/vip-service"
    },
    {
      id: 6,
      title: "時間管理の美学",
      excerpt: "効率的でありながら優雅な時間の使い方と、スケジュール管理のコツをお伝えします。",
      category: "butler-skills",
      categoryName: "執事スキル",
      readTime: "5分",
      image: "/images/generated/seq-time-management-asian-2b73b2.jpg",
      href: "/wisdom/articles/time-management"
    },
    {
      id: 7,
      title: "観察力を磨く技術",
      excerpt: "相手のニーズを察知し、先回りしたサービスを提供するための観察スキルを身につけましょう。",
      category: "butler-skills",
      categoryName: "執事スキル",
      readTime: "7分",
      image: "/images/generated/seq-observation-asian-0b4cdd.jpg",
      href: "/wisdom/articles/observation"
    },
    {
      id: 8,
      title: "美しい話し方の基本",
      excerpt: "声の出し方から言葉遣いまで、品格のある話し方をマスターするためのガイドです。",
      category: "elegance",
      categoryName: "日常の品格",
      readTime: "6分",
      image: "/images/generated/seq-speech-asian-a67420.jpg",
      href: "/wisdom/articles/speech"
    },
    {
      id: 9,
      title: "整理整頓の哲学",
      excerpt: "美しく機能的な空間作りと、効率的な整理整頓の方法について詳しく解説します。",
      category: "elegance",
      categoryName: "日常の品格",
      readTime: "8分",
      image: "/images/generated/seq-organization-asian-cdac08.jpg",
      href: "/wisdom/articles/organization"
    },
    {
      id: 10,
      title: "社交マナーの極意",
      excerpt: "パーティーや社交の場での振る舞い方と、印象に残る自己紹介のテクニックをご紹介します。",
      category: "etiquette",
      categoryName: "フォーマルマナー",
      readTime: "9分",
      image: "/images/generated/seq-social-etiquette-asian-fc1a6c.jpg",
      href: "/wisdom/articles/social-etiquette"
    },
    {
      id: 11,
      title: "執事としての心構え",
      excerpt: "プロフェッショナルとしての誇りと、サービス精神を育むための心の持ち方について語ります。",
      category: "hospitality",
      categoryName: "おもてなしの心",
      readTime: "12分",
      image: "/images/generated/seq-mindset-asian-684e15.jpg",
      href: "/wisdom/articles/mindset"
    },
    {
      id: 12,
      title: "日常に取り入れる上質な習慣",
      excerpt: "毎日の生活を豊かにする小さな習慣と、品格を高める日常のルーティンをお教えします。",
      category: "elegance",
      categoryName: "日常の品格",
      readTime: "6分",
      image: "/images/generated/seq-daily-routine-asian-9ac344.jpg",
      href: "/wisdom/articles/daily-routine"
    }
  ];

  const columns = (columnData as WisdomColumn[]).map((column, index) => ({
    id: 1000 + index,
    title: column.title,
    excerpt: column.sections.flatMap((section) => section.paragraphs).join(' ').slice(0, 120),
    category: column.category,
    categoryName: columnCategoryNames[column.category],
    readTime: `${Math.max(5, Math.ceil(column.sections.flatMap((section) => section.paragraphs).join('').length / 400))}分`,
    image: '/images/generated/seq-wisdom-hero-library-4be2bb.jpg',
    href: `/wisdom/columns/${column.slug}`
  }));
  const allArticles = [...articles, ...columns];

  const filteredArticles = selectedCategory === 'all' 
    ? allArticles
    : allArticles.filter(article => article.category === selectedCategory);

  const featuredArticle = articles.find(article => article.featured);

  return (
    <PageLayout hero={<>
<section 
          className="relative py-32 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/generated/seq-articles-hero-bg-4f4e81.jpg')`
          }}
        >
          <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
            <div className="mb-8">
              <span className="inline-block bg-amber-600/20 backdrop-blur-sm text-amber-200 px-6 py-3 rounded-full text-sm font-medium border border-amber-400/30">
                Wisdom Articles
              </span>
            </div>
            <h1 className="text-4xl md:text-6xl font-serif text-white mb-8 leading-tight">
              執事の知恵 記事一覧
            </h1>
            <p className="text-lg md:text-xl text-amber-100 max-w-6xl mx-auto leading-relaxed">
              30年の経験から培った実践的な知識とノウハウを、詳細な記事でお届けします
            </p>
          </div>
        </section>
</>}>
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        

        {/* Featured Article */}
        {featuredArticle && (
          <section className="py-20 bg-gradient-to-b from-amber-50 to-white">
            <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <div className="mb-4">
                  <span className="inline-block bg-amber-200 text-amber-800 px-5 sm:px-6 lg:px-8 py-2 rounded-full text-sm font-medium">
                    Featured Article
                  </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                  注目の記事
                </h2>
              </div>
              
              <Link
                to={featuredArticle.href}
                className="group block bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer"
              >
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                  <div className="relative overflow-hidden">
                    <img
                      src={featuredArticle.image}
                      alt={featuredArticle.title}
                      className="w-full h-80 lg:h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute top-6 left-6">
                      <span className="bg-amber-700 text-white px-3 py-1 rounded-full text-sm font-medium">
                        {featuredArticle.categoryName}
                      </span>
                    </div>
                  </div>
                  <div className="p-8 lg:p-12 flex flex-col justify-center">
                    <div className="mb-4">
                      <span className="text-amber-700 text-sm font-medium">
                        読了時間: {featuredArticle.readTime}
                      </span>
                    </div>
                    <h3 className="text-3xl lg:text-4xl font-serif text-gray-900 mb-6 group-hover:text-amber-700 transition-colors duration-300">
                      {featuredArticle.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-8 text-lg">
                      {featuredArticle.excerpt}
                    </p>
                    <div className="flex items-center text-amber-700 group-hover:text-amber-800 font-medium">
                      <span>記事を読む</span>
                      <span className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300">
                        →
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </section>
        )}

        {/* Category Filter */}
        <section className="py-12 bg-gray-50">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-4">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    selectedCategory === category.id
                      ? 'bg-amber-700 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-amber-50 hover:text-amber-700 shadow-md'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles.map((article, index) => (
                <Link
                  key={index}
                  to={article.href}
                  className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-56 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-white/90 backdrop-blur-sm text-amber-800 px-3 py-1 rounded-full text-xs font-medium">
                        {article.categoryName}
                      </span>
                    </div>
                    <div className="absolute top-4 right-4">
                      <span className="bg-black/70 text-white px-2 py-1 rounded text-xs">
                        {article.readTime}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-serif text-gray-900 mb-3 group-hover:text-amber-700 transition-colors duration-300">
                      {article.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                      {article.excerpt.length > 100 ? `${article.excerpt.substring(0, 100)}...` : article.excerpt}
                    </p>
                    <div className="flex items-center text-amber-700 group-hover:text-amber-800 font-medium text-sm">
                      <span>詳しく読む</span>
                      <span className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300">
                        →
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="py-20 bg-gradient-to-r from-gray-900 to-gray-800">
          <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6">
              最新の記事をお届け
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              新しい知恵や実践的なノウハウを定期的にお送りします
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
              <input
                type="email"
                placeholder="メールアドレス"
                className="flex-1 px-5 sm:px-6 lg:px-8 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
              />
              <button className="bg-amber-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-amber-800 transition-colors whitespace-nowrap cursor-pointer">
                購読する
              </button>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-amber-600 to-amber-700">
          <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6">
              実践的な学びをお求めの方へ
            </h2>
            <p className="text-xl text-amber-100 mb-8 leading-relaxed">
              記事で学んだ知識を実際に身につけるための研修やコンサルティングを承っております
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/services"
                className="inline-block bg-white text-amber-800 px-8 py-4 rounded-lg font-medium hover:bg-amber-50 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                サービス一覧
              </Link>
              <Link
                to="/contact"
                className="inline-block bg-amber-800 text-white px-8 py-4 rounded-lg font-medium hover:bg-amber-900 transition-all duration-300 border border-amber-500 whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </Link>
            </div>
          </div>
        </section>
      </div>
    </PageLayout>
  );
};

export default WisdomArticles;
